var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon-terminal-manual"},[_c('icon-terminal'),_c('span',{staticClass:"icon-terminal-manual_badge"},[_c('v-icon',{attrs:{"size":"22","color":"#fff"}},[_vm._v("mdi-dialpad")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }